import * as React from 'react';
import { useEffect } from 'react';

const Unauthorized = (props) => {
    var redirectPath = sessionStorage.getItem("UrlPath");
    var isOIN = sessionStorage.getItem("OIN");
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    useEffect(() => {
        redirectPath = sessionStorage.getItem("UrlPath");
        if (sessionStorage.getItem('azureInit') != null) {
            if (localStorage.length > 0) {
                localStorage.clear();
            }
            if (sessionStorage.length > 0) {
                sessionStorage.clear();
            }
        }
    }, []); 
    const RedirectToLogin = () => {
        if (sessionStorage.getItem("UrlPath")) {
            //var redirectPath = sessionStorage.getItem("UrlPath");
            //props.history.push('/matson');
                if (localStorage.length > 0) {
                    localStorage.clear();
                }
                if (sessionStorage.length > 0) {
                    sessionStorage.clear();
            }
            if (isOIN) {
                sessionStorage.setItem('OIN', 'True');
            }
            window.location.href = redirectPath;
        } 
        else
            {
            //props.history.push('/home');
            if (localStorage.length > 0) {
                localStorage.clear();
            }
            if (sessionStorage.length > 0) {
                sessionStorage.clear();
            }
            sessionStorage.removeItem("UserInfo");
            window.location.href = '/';
            }
    };
    return (
        <div>

            <div className='FilenotFoundbBG'>
                <div className='clockIcon'> <span className="far fa-clock"></span> </div>
                <div className='PageNotFoundText'>Session expired. Please sign in again.</div>

                <div className='PageNotFoundBtn'> {sessionStorage.getItem('AZRD') != null ? '' : <button type="button" className='btn btn btn-primary' onClick={RedirectToLogin}>OK</button>}</div>
            </div>
            
        </div>
    );
};

export default Unauthorized;
